module.exports = __webpack_public_path__ + "static/Lucas_Logo_Eng-cd0da23741abb1a67f492dbf7a23d600.svg";